/* eslint-disable no-unused-vars */
import React from 'react';
import { ReactComponent as Prelanzamiento } from 'assets/icons/project-category-pre-lanzamiento.svg';
import { ReactComponent as Events } from 'assets/icons/project-category-events.svg';
import { ReactComponent as Culture } from 'assets/icons/project-category-culture.svg';
import { ReactComponent as Technology } from 'assets/icons/project-category-technology.svg';
import { ReactComponent as Sport } from 'assets/icons/project-category-sport.svg';
import { ReactComponent as Property } from 'assets/icons/project-category-property.svg';
import { ReactComponent as Art } from 'assets/icons/project-category-art.svg';
import { ReactComponent as Food } from 'assets/icons/project-category-food.svg';
import { ReactComponent as Industry } from 'assets/icons/project-category-industry.svg';
import { ReactComponent as Design } from 'assets/icons/project-category-design.svg';
import { ReactComponent as Health } from 'assets/icons/project-category-health.svg';
import { ReactComponent as Closed } from 'assets/icons/project-category-closed.svg';
import { ReactComponent as SocialImpact } from 'assets/icons/project-category-socialImpact.svg';
import { ReactComponent as Other } from 'assets/icons/project-category-others.svg';
import { ReactComponent as Innovation } from 'assets/icons/project-category-innovation.svg';
import { ReactComponent as Launch } from 'assets/icons/project-category-launch.svg';

export function getCategoryProject(category, color) {
  if (category.includes('Prelanzamiento')) {
    return {
      imageCategory: <Prelanzamiento color={color} />,
      nameCategory: 'Prelanzamiento',
    };
  }
  if (category.includes('Eventos')) {
    return {
      imageCategory: <Events color={color} />,
      nameCategory: 'Eventos',
    };
  }
  if (category.includes('Cultura')) {
    return {
      imageCategory: <Culture color={color} />,
      nameCategory: 'Cultura',
    };
  }
  if (category.includes('Tecnología')) {
    return {
      imageCategory: <Technology color={color} />,
      nameCategory: 'Tecnología',
    };
  }
  if (category.includes('Deportes')) {
    return {
      imageCategory: <Sport color={color} />,
      nameCategory: 'Deportes',
    };
  }
  if (category.includes('Inmobiliario')) {
    return {
      imageCategory: <Property color={color} />,
      nameCategory: 'Inmobiliario',
    };
  }
  if (category.includes('Arte')) {
    return {
      imageCategory: <Art color={color} />,
      nameCategory: 'Arte',
    };
  }
  if (category.includes('Alimentos')) {
    return {
      imageCategory: <Food color={color} />,
      nameCategory: 'Alimentos',
    };
  }
  if (category.includes('Industria')) {
    return {
      imageCategory: <Industry color={color} />,
      nameCategory: 'Industria',
    };
  }

  if (category.includes('Diseño')) {
    return {
      imageCategory: <Design color={color} />,
      nameCategory: 'Diseño',
    };
  }
  if (category.includes('Salud')) {
    return {
      imageCategory: <Health color={color} />,
      nameCategory: 'Salud',
    };
  }
  if (category.includes('Proyecto Cerrado')) {
    return {
      imageCategory: <Closed color={color} />,
      nameCategory: 'Proyecto Cerrado',
    };
  }
  if (category.includes('Impacto Social')) {
    return {
      imageCategory: <SocialImpact color={color} />,
      nameCategory: 'Impacto Social',
    };
  }
  if (category.includes('Otros')) {
    return {
      imageCategory: <Other color={color} />,
      nameCategory: 'Otros',
    };
  }
  if (category.includes('Innovación')) {
    return {
      imageCategory: <Innovation color={color} />,
      nameCategory: 'Innovación',
    };
  }
  if (category.includes('Proyecto Lanzamiento')) {
    return {
      imageCategory: <Launch color={color} />,
      nameCategory: 'Proyecto Lanzamiento',
    };
  }

  return { undefined, category };
}
